import { useCallback } from "react";
import { useAuthStore } from "../store/useAuthStore";
import { useGameStore } from "../store/useGameStore";
import { authStorage, prefStorage } from "../utils/storage";
import { launchGame } from "../services/gameService";
import { showError } from "../utils/toast";

export function useGameLaunch() {
  const { isAuthenticated } = useAuthStore();

  const handleGameClick = useCallback(async (game) => {
    if (!isAuthenticated) {
      showError("Please login to play");
      return;
    }

    const currency = prefStorage.getCurrency();
    if (!["USDT", "INR", "BDT"].includes(currency)) {
      showError("Please Swap Into USDT To Play");
      return;
    }

    const userId = authStorage.getUserId();
    const gameUid = game?.game_uid || game?.id;

    if (!gameUid) {
      showError("Game not available");
      return;
    }

    useGameStore.getState().setGameLoading(true);
    useGameStore.getState().launchGame(null);

    const url = await launchGame(gameUid, userId, currency);

    if (url) {
      useGameStore.getState().launchGame(url);
    } else {
      useGameStore.getState().closeGame();
      showError("Game under maintenance");
    }
  }, [isAuthenticated]);

  return handleGameClick;
}
